import type { IAdaptShareholders } from '@/types/shared-types'

type FetchShareholdersOptions = {
  selectedChartVariant?: Ref<string>
}

export const useFetchShareholders = async (options: FetchShareholdersOptions = {}) => {
  const { locale } = useI18n()
  const route = useRoute()
  const selectedChartVariant = options.selectedChartVariant

  async function fetchShareholders() {
    return await useAsyncData(
      () => `shareholders-${route.path}-${locale.value}-${selectedChartVariant?.value ?? ''}`,
      async () => {
        const response = await $fetch<{ shareholders: IAdaptShareholders | null }>(
          '/api/v1/contentful/investor/shareholders',
          {
            query: {
              locale: locale.value,
              path: route.path,
            },
          })
        return response?.shareholders ?? null
      })
  }

  return {
    fetchShareholders,
  }
}
